/**
 * Author: Romain Hapi Sr.
 * Version: 1.0
 * Date: 2026-06-25
 * Project: Prenim Digital
 * Copyright: Prenim UK
 */
/**
 * Adresses des images du site UK, rassemblees en un point.
 *
 * Les visuels de marque (heros, logos, carte) sont servis depuis `public/` ;
 * les photographies d'illustration viennent de Pexels, en lien direct. Ces
 * dernieres dependent donc d'un service tiers : pour qu'elles resistent a une
 * coupure, il faudrait les rapatrier sous `public/images/`.
 *
 * `SERVICE_IMAGES` associe une image distincte a chaque service : la page de
 * detail en affiche une en tete, et deux services partageant la meme photo se
 * remarquent immediatement.
 */
// Centralised media URLs from design guidelines + extra images for service detail pages
const MEDIA = {
  hero_background: "/images/hero-uk.webp",
  logo_uk: "/images/logo-prenim-uk.webp",
  logo_tchad: "/images/logo-prenim-tchad.webp",
  map_reach: "/images/map_reach.webp",
  digital_transformation: "/images/digital_transformation.webp",
  african_tech_team_1:
    "https://images.pexels.com/photos/9490631/pexels-photo-9490631.jpeg",
  african_tech_team_2:
    "https://images.pexels.com/photos/3894376/pexels-photo-3894376.jpeg",
  server_infrastructure:
    "https://images.pexels.com/photos/5408005/pexels-photo-5408005.jpeg",
  leeds_office:
    "https://images.pexels.com/photos/30404020/pexels-photo-30404020.jpeg",
  healthcare_project:
    "https://images.pexels.com/photos/15277956/pexels-photo-15277956.jpeg",
  logistics_project:
    "https://images.pexels.com/photos/5025643/pexels-photo-5025643.jpeg",
  // Service-specific imagery
  consulting_meeting:
    "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg",
  web_dev_code:
    "https://images.pexels.com/photos/270404/pexels-photo-270404.jpeg",
  desktop_dev:
    "https://images.pexels.com/photos/4974915/pexels-photo-4974915.jpeg",
  devops_pipeline:
    "https://images.pexels.com/photos/1181263/pexels-photo-1181263.jpeg",
  networking_cables:
    "https://images.pexels.com/photos/2881229/pexels-photo-2881229.jpeg",
  training_session:
    "https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg",
};

// Distinct image per service slug (no duplicates)
export const SERVICE_IMAGES = {
  "digital-transformation": MEDIA.digital_transformation,
  consulting: MEDIA.consulting_meeting,
  "system-integration": MEDIA.server_infrastructure,
  "web-development": MEDIA.web_dev_code,
  "desktop-development": MEDIA.desktop_dev,
  devops: MEDIA.devops_pipeline,
  networking: MEDIA.networking_cables,
  training: MEDIA.training_session,
};

export default MEDIA;
